import { render, staticRenderFns } from "./add-enum-language.vue?vue&type=template&id=89062d12&"
import script from "./add-enum-language.vue?vue&type=script&lang=js&"
export * from "./add-enum-language.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports